/* eslint-disable */
/* tslint:disable */

/** applyToHubloPoolOffer
 * method: post
 * summary: Apply to a Hublo Pool Offer
 */

import type { GeneralOkNotOkResultDto, ApiResponseDto } from './../api-types'

export const getPath = (idHubloOffer: string): string =>
  `/bff-worker/pool/offer/${idHubloOffer}/apply`
export const getFullPath = (idHubloOffer: string): string =>
  `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/pool/offer/${idHubloOffer}/apply`

export type ApplyToHubloPoolOfferSuccess = GeneralOkNotOkResultDto
export type ApplyToHubloPoolOfferError = ApiResponseDto
